import PropTypes from 'prop-types';
import React from 'react';

import { SelectInput } from 'Shared/form/SelectField';

const options = [
    { value: undefined, label: 'All' },
    { value: true, label: 'My Pharmacy' },
    { value: false, label: 'Therigy' },
];

const CreatedByFilter = ({ column: { filterValue, setFilter } }) => {
    return (
        <SelectInput
            name="createdBy"
            aria-label="Created By"
            value={options.find((o) => o.value === filterValue)}
            onChange={(opt) => setFilter(opt.value)}
            options={options}
        />
    );
};
CreatedByFilter.propTypes = {
    column: PropTypes.shape({
        filterValue: PropTypes.bool,
        setFilter: PropTypes.func,
    }).isRequired,
};

export default CreatedByFilter;
